type RetoolingOverflowProps = {
  width: number;
};

export const RetoolingOverflow = ({ width }: RetoolingOverflowProps) => (
  <div className="bg-surface-retooling overflow-hidden, absolute left-0 h-full" style={{ width: `${width}px` }} />
);
